export const XIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='32'
    height='32'
    viewBox='0 0 24 24'
    fill='currentColor'
    {...props}
  >
    {/* X (formerly Twitter) logo */}
    <path d='M18.244 2H21l-7.51 8.278L22 22h-6.777l-4.36-6.003L5.6 22H2l8.045-9.207L2 2h6.777l4.023 5.539L18.244 2zm-1.187 18h1.27L7.348 4h-1.27L17.057 20z' />
  </svg>
);
